// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","disabled":"Button_disabled__PUkNe","secondary":"Button_secondary__QwN49"};